import { Link } from "react-router-dom";

/**
 * StageBreadcrumb — full S0 → S4 stage progression pill.
 * Used in every diagnostic / advisory landing page (S0, S1, S2.1, S2.2, S2.3, S3, S4).
 *
 * Props:
 *   currentStage — the stage label the visitor is on ("S0" | "S1" | "S2.1" | "S2.2" | "S2.3" | "S3" | "S4").
 *
 * Stages BEFORE `currentStage` render with ✓ done, current renders as filled pill,
 * stages AFTER current render greyed out.
 */
const STAGES = [
  { stage: "S0",   to: "/S0diagnostic",  name: "Founder Signal Test" },
  { stage: "S1",   to: "/s1diagnostic",  name: "Founder Reality Check" },
  { stage: "S2.1", to: "/S21diagnostic", name: "Founder Archetype" },
  { stage: "S2.2", to: "/S22diagnostic", name: "Founder Durability" },
  { stage: "S2.3", to: "/S23diagnostic", name: "Founder Capability & Execution" },
  { stage: "S3",   to: "/strategyblueprint",      name: "Strategy Blueprint" },
  { stage: "S4",   to: "/founderoperatingsystem", name: "Founder Operating System" },
];

export default function StageBreadcrumb({ currentStage, testId = "stage-breadcrumb" }) {
  const currentIndex = STAGES.findIndex((s) => s.stage === currentStage);

  return (
    <nav className="sd-breadcrumb" data-testid={testId} aria-label="Pivotbox stage progression">
      {STAGES.map((r, i, arr) => {
        const isDone = currentIndex >= 0 && i < currentIndex;
        const isCurrent = currentIndex >= 0 && i === currentIndex;
        const cls = [
          "sd-breadcrumb__item",
          isDone ? "sd-breadcrumb__item--done" : "",
          isCurrent ? "sd-breadcrumb__item--current" : "",
        ].filter(Boolean).join(" ");
        const linkable = !isCurrent;
        const inner = (
          <>
            <span className="sd-breadcrumb__icon" aria-hidden="true">
              {isDone ? "\u2713" : (isCurrent ? "\u25CF" : "")}
            </span>
            <span className="sd-breadcrumb__stage">{r.stage}</span>
          </>
        );
        return (
          <span key={r.stage} className="sd-breadcrumb__group">
            {linkable ? (
              <Link
                to={r.to}
                className={`${cls} sd-breadcrumb__item--link`}
                title={r.name}
                data-testid={`${testId}-${r.stage}`}
              >
                {inner}
              </Link>
            ) : (
              <span className={cls} title={r.name} data-testid={`${testId}-${r.stage}`}>
                {inner}
              </span>
            )}
            {i < arr.length - 1 && <span className="sd-breadcrumb__sep" aria-hidden="true">&middot;</span>}
          </span>
        );
      })}
    </nav>
  );
}
